import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';

/**
 * Сегментированный 3-позиционный переключатель: Light / Auto / Dark.
 * Активный сегмент — определяется парой (theme, source).
 *  - source === 'system' → активен Auto.
 *  - source === 'user'   → активен Light или Dark в зависимости от theme.
 */
export default function ThemeToggle({ theme, source, onLight, onAuto, onDark }) {
  const activeKey = source === 'system' ? 'auto' : theme; // 'light' | 'dark' | 'auto'

  const segments = [
    { key: 'light', Icon: Sun,     label: 'Світла',    onClick: onLight },
    { key: 'auto',  Icon: Monitor, label: 'Авто',      onClick: onAuto  },
    { key: 'dark',  Icon: Moon,    label: 'Темна',     onClick: onDark  },
  ];

  return (
    <div
      role="group"
      aria-label="Тема оформлення"
      className="inline-flex items-center gap-0.5 p-0.5 rounded-md border border-border-default bg-app"
    >
      {segments.map(({ key, Icon, label, onClick }) => {
        const isActive = activeKey === key;
        return (
          <button
            key={key}
            type="button"
            onClick={onClick}
            aria-pressed={isActive}
            aria-label={label}
            title={label}
            className={`flex items-center justify-center w-7 h-7 rounded transition-colors
              ${isActive
                ? 'bg-surface text-text-primary shadow-sm ring-1 ring-border-strong'
                : 'text-text-muted hover:text-text-primary hover:bg-hover'}`}
          >
            <Icon className="w-3.5 h-3.5" />
          </button>
        );
      })}
    </div>
  );
}
